// extracted by mini-css-extract-plugin
export default {"best_offer_container":"components_best_offer_container__LtR+h","form_button":"components_form_button__icfc3"};